export enum CollectionNames {
    UserCustomProperties = 'usercustomproperties',
}
